var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9188 2.125H3.08125C2.55 2.125 2.125 2.55 2.125 3.02812V13.9188C2.125 14.3969 2.55 14.8219 3.08125 14.8219H13.9188C14.45 14.8219 14.875 14.3969 14.875 13.9188V3.02812C14.875 2.55 14.45 2.125 13.9188 2.125ZM5.89688 12.9625H4.0375V6.90625H5.89688V12.9625ZM4.99375 6.05625C4.40937 6.05625 3.87813 5.57813 3.87813 4.94063C3.87813 4.30313 4.35625 3.825 4.99375 3.825C5.57812 3.825 6.10938 4.30313 6.10938 4.94063C6.10938 5.57813 5.57812 6.05625 4.99375 6.05625ZM13.0156 12.9094H11.1562V9.93438C11.1562 9.24375 11.1562 8.2875 10.1469 8.2875C9.1375 8.2875 9.03125 9.08437 9.03125 9.82812V12.8563H7.17188V6.90625H8.925V7.70312H8.97812C9.24375 7.225 9.88125 6.69375 10.7844 6.69375C12.6969 6.69375 13.0688 7.96875 13.0688 9.61563V12.9094H13.0156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo-linkedin.b5b679d5159b7c0dbf71b42c3adaa124.svg";
export { ForwardRef as ReactComponent };